import React from "react";
import {styled} from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import {ListSubheader} from "@mui/material";
import {blue} from "../../../common/colors";

const CssField = styled(TextField)(() => ({
    children: {
        maxHeight: '50vh',
    },
    label: {
        top: '-6px'
    },
    "& .MuiOutlinedInput-notchedOutline": {
        fontSize: "1.25em",
        borderWidth: '2px',
        borderColor: '#868686',
        color: '#868686',
    },
    "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#28ade0"
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#28ade0"
    },
    "& .MuiSelect-select": {
        padding: "7px 15px",
        fontSize: "1.25em",
        color: "#20312D",
    },
    "& .MuiFormLabel-root.Mui-focused": {
        color: blue
    },
}));

/**
 *
 * const data = [
 *     {
 *         value: 1,
 *         name: 'Просто'
 *     },
 * ]
 */
export default function SelectTextEdit(props) {
    const {data, label, onChange, value} = props;

    return (
        <CssField
            {...props}
            multiple
            SelectProps={{
                MenuProps: {
                    sx: {
                        zIndex: 1400
                    },
                    PaperProps: {
                        sx: {
                            maxHeight: '50vh'
                        }
                    }
                }
            }}
            variant="outlined"
            select
            defaultValue=""
            label={label}
            value={value || ''}
            onChange={onChange ? onChange : () => {
            }}>
            {
                data
                    ? data.map((item, i) =>
                        item.category
                            ? <ListSubheader key={"CssField-" + i}>{item.category}</ListSubheader>
                            : <MenuItem key={"CssField-" + item.value} value={item.value}>
                                {item.name}
                            </MenuItem>)
                    : <MenuItem value={"null"}></MenuItem>
            }
        </CssField>
    )
}

SelectTextEdit.propTypes = {
    data: PropTypes.array,
    label: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    onChange: PropTypes.func,
}